import { PRODUCTS_PER_PAGE } from "../constants/wordpress";
import { mapWooCategory, mapWooProduct } from "../utils/mapWooProduct";
import { wpFetch } from "./wordpressClient";

export async function getProducts({
  page = 1,
  categoryId,
  search,
  perPage = PRODUCTS_PER_PAGE,
  exclude,
  include,
} = {}) {
  const searchParams = {
    page: String(page),
    per_page: String(perPage),
    status: "publish",
  };

  if (categoryId) {
    searchParams.category = String(categoryId);
  }

  if (search?.trim()) {
    searchParams.search = search.trim();
  }

  if (exclude) {
    searchParams.exclude = String(exclude);
  }

  if (include?.length) {
    searchParams.include = include.join(",");
    searchParams.per_page = String(include.length);
  }

  const { data, total, totalPages } = await wpFetch("/products", { searchParams });

  return {
    products: data.map(mapWooProduct).filter(Boolean),
    total,
    totalPages,
    page,
  };
}

export async function getProductsByIds(ids = []) {
  if (!ids.length) return [];

  const { products } = await getProducts({
    include: ids.map(String),
    perPage: ids.length,
  });

  const orderMap = new Map(ids.map((id, index) => [id, index]));
  return products.sort(
    (a, b) => (orderMap.get(a.id) ?? 999) - (orderMap.get(b.id) ?? 999),
  );
}

export async function getRelatedProducts({
  productId,
  categoryId,
  relatedIds = [],
  limit = 4,
}) {
  if (relatedIds.length) {
    const products = await getProductsByIds(relatedIds.slice(0, limit));
    return products.filter((product) => product.id !== productId);
  }

  if (!categoryId) return [];

  const { products } = await getProducts({
    categoryId,
    perPage: limit + 1,
    exclude: productId,
  });

  return products.filter((product) => product.id !== productId).slice(0, limit);
}

export async function getProductBySlug(slug) {
  const { data } = await wpFetch("/products", {
    searchParams: { slug, status: "publish" },
  });

  const product = data[0];
  return product ? mapWooProduct(product) : null;
}

export async function getProductCategories() {
  const { data } = await wpFetch("/products/categories", {
    searchParams: { per_page: "100", hide_empty: "true" },
  });

  return data.map(mapWooCategory).filter(Boolean);
}
